import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery.css'; // Core CSS for lightGallery
//  import fonts
// import 'lightgallery/css/lg.css';
// import 'lightgallery/css/fontawesome.css';

// Plugins
// import lgThumbnail from 'lightgallery/plugins/thumbnail'
// import lgZoom from 'lightgallery/plugins/zoom'

lightGallery(document.getElementById('ul-li'));